import Commander from "./Commander";
import {pixiSetTimeout} from "../framework/src/engine/pixi/pixiTimeout";
import {CONFIG_PARAMS, MODES} from "../framework/src/system/SystemConfig";

export default class StickingWild {

    constructor (commander) {
        this.commander = commander;
        this.BlinkAnimation = this.commander.BlinkAnimation;
        this.BigWin = this.commander.BigWin;

        this.reels = this.commander.slots.getReels();
        this.layer = {
            wild: this.commander.layers.wild,
            joker: this.commander.layers.joker
        };

        this.reelBg = [];
        this.jokers = [];

        this.reels = this.commander.slots.getReels();
    }

    init() {
        for (let reel of this.reels) {
            let x = reel.getResSymbols()[0].x;

            // add background for highlighting reels
            let reelHighlight = new PIXI.Container();
            StickingWild.addBackground(reelHighlight, x);
            StickingWild.addLights(reelHighlight, x);

            reelHighlight.visible = false;
            this.layer.wild.addChild(reelHighlight);
            this.reelBg.push(reelHighlight);

            // add background and joker for joker reels
            let jokerReel = new PIXI.Container();
            StickingWild.addBackground(jokerReel, x);
            StickingWild.addLights(jokerReel, x);
            StickingWild.addJoker(jokerReel, x);

            jokerReel.visible = false;
            this.layer.joker.addChild(jokerReel);
            this.jokers.push(jokerReel);

            this.fpText = Commander.getSprite("full_screen_big.png", 640, 400);
            this.fpText.visible = false;
            this.BigWin.layer.flares.addChild(this.fpText);
        }
    }

    setWildMemory(wildMemory) {
        try {
            this.wildMemory = wildMemory;
            this.hideReelsBg();
            // reel is number of reel with same symbols, here the joker appears next round
                for (let reel of this.wildMemory[this.getBetIndex()]) {
                    this.highlightReel(reel);
                }
            // true if full plate
            this.commander.fullPlate = this.wildMemory[this.getBetIndex()].length === 5;
        } catch (e) {
            console.error("Error while setting Wild Memory:", e);
        }
    }

    highlightReel(index) {
        if (this.commander.freespins.isInFreeSpins())
            this.commander.audio.fadeInPlaying("bonus_Joker_Idle_Loop_FS", 1);
        else
            this.commander.audio.fadeInPlaying("bonus_Joker_Idle_Loop_Normal", 1);
        let reel = this.reels[index];
        for (let sprite of reel.getResSymbols())  // blink symbols
            this.BlinkAnimation.addTarget(sprite, "wild");
        this.showReelBg(index);
    }

    drawJokers() {
        if (
            this.commander.config.get(CONFIG_PARAMS.MODE) === MODES.REPLAY &&
            !this.commander.game.isInFreeSpins() &&
            !this.commander.config.get(CONFIG_PARAMS.REPLAY_RESULT)?.getFreeSpinResults()
        ) {
            this.commander.slots.reels.getReels().forEach((reel) => {
                if (this.is4Wilds(reel.getResSymbols())) {
                    this.showJoker(reel.getId());
                    this.hideReelBg(reel.getId());
                }
            })
            return
        }
        for (let i = 0; i < this.reelBg.length; i++) {
            if (this.reelBg[i].visible === true) {
                this.showJoker(i);
                this.hideReelBg(i);
            }
        }
    }

    is4Wilds(resSymbols) {
        return resSymbols.every((symbol) => symbol.symbolIndex === 9)
    }

    drawJokersFs() {
        for (let i = 0; i < this.reelBg.length; i++) {
            if (i === 1 || i === 3) {
                if (this.reelBg[i].visible === true) {
                    this.showJoker(i);
                    this.hideReelBg(i);
                }
            }
        }
    }

    showJoker(index) {
        this.reels[index].data.joker = true;
        if (!this.commander.audio.isPlaying("bonus_Joker_Expand") && !this.reels[index].data.redJoker)
            this.commander.audio.playTrack("bonus_Joker_Expand");
        this.jokers[index].alpha = 0;
        this.jokers[index].visible = true;
        this.jokers[index].y = 0;
        this.jokers[index].hide = false;
        Commander.unblurSymbol(this.jokers[index].children[3]);
        this.reels[index].setSymbolsVisible(false);
        this.jokers[index].children[1].play();
        this.jokers[index].children[2].play();
        Commander.removeTween(this.jokers[index]);
        createjs.Tween.get(this.jokers[index])
            .to({alpha: 1}, 300)
            .call(() => {
                Commander.removeTween(this.jokers[index]);
            });
    }

    hideJokers() {
        for (let i = 0; i < this.jokers.length; i++) {
            if (this.jokers[i].visible === true) {
                this.reels[i].data.redJoker = this.reels[i].data.joker = false;
                this.hideJoker(i);
            }
        }
    }

    hideJokersFs() {
        for (let i = 0; i < this.jokers.length; i++) {
            if (i === 1 || i === 3) {
                this.reels[i].data.redJoker = this.reels[i].data.joker = false;
                if (this.jokers[i].visible === true)
                    this.hideJoker(i);
            }
        }
    }

    hideJoker(index) {
        this.commander.audio.fadeOutTrack("bonus_Joker_Idle_Loop_Normal", 0.2);
        this.commander.audio.fadeOutTrack("bonus_Joker_Idle_Loop_FS", 0.2);
        Commander.removeTween(this.jokers[index]);
        this.jokers[index].hide = true;
    }

    instantHideJokers() {
        for (let i = 0; i < this.jokers.length; i++) {
            this.reels[i].data.redJoker = this.reels[i].data.joker = false;
            this.instantHideJoker(i);
        }
    }

    instantHideJoker(index) {
        this.jokers[index].visible = false;
        this.jokers[index].alpha = 1;
    }

    endFs() {
        for (let i = 0; i < this.jokers.length; i++) {
            this.reels[i].setSymbolsVisible(true);
            createjs.Tween.get(this.jokers[i])
                .to({alpha: 0}, 300)
                .call(() => {
                    Commander.removeTween(this.jokers[i]);
                    this.jokers[i].visible = false;
                    this.jokers[i].alpha = 1;
                });
        }
    }

    showReelBg(index) {
        this.reelBg[index].visible = true;
        this.reelBg[index].children[1].play();
        this.reelBg[index].children[2].play();

    }

    hideReelsBg() {
        for (let i = 0; i < 5; i++)
            this.hideReelBg(i);
        this.BlinkAnimation.clearWildFilters();
    }

    hideReelBg(index) {
        this.reelBg[index].visible = false;
        this.reelBg[index].children[1].stop();
        this.reelBg[index].children[2].stop();
        this.commander.audio.fadeOutTrack("bonus_Joker_Idle_Loop_Normal", 0.2);
        this.commander.audio.fadeOutTrack("bonus_Joker_Idle_Loop_FS", 0.2);

    }

    redBackground() {
        this.reels[0].data.redJoker = this.reels[2].data.redJoker = this.reels[4].data.redJoker = true;
        this.jokers[0].children[0].texture = new PIXI.Texture.from("sticking_wild_background_red.png");
        this.jokers[2].children[0].texture = new PIXI.Texture.from("sticking_wild_background_red.png");
        this.jokers[4].children[0].texture = new PIXI.Texture.from("sticking_wild_background_red.png");
    }

    blueBackground() {
        for (let joker of this.jokers) {
            joker.children[0].texture = new PIXI.Texture.from("sticking_wild_background_blue.png");
        }
    }

    fullPlate() {
        return new Promise(res => {
            this.BigWin.layer.flares.visible = true;
            this.BigWin.animateFlares(2700);
            this.commander.audio.playTrack("win_FullPlate");
            this.fullPlateText(2700);
            pixiSetTimeout(2.9, () => {
                this.commander.audio.fadeOutTrack("win_FullPlate", 0.2);
                res();
            });
        });
    }

    fullPlateText() {
        this.fpText.visible = true;
        this.BigWin.textAnimation(this.fpText, 3000, "fp");
    }

    static addLights(container, x) {
        let left = new PIXI.AnimatedSprite([
            new PIXI.Texture.from('frane_lights_even.png'),
            new PIXI.Texture.from('frane_lights_odd.png')
        ]);
        left.loop = true;
        left.animationSpeed = .1;
        left.position.set(x-140, 25);
        container.addChild(left);


        let right = new PIXI.AnimatedSprite([
            new PIXI.Texture.from('frane_lights_even.png'),
            new PIXI.Texture.from('frane_lights_odd.png')
        ]);
        right.loop = true;
        right.animationSpeed = .1;
        right.position.set(x+60, 25);
        container.addChild(right);
    }

    static addBackground(container, x) {
        let bg = Commander.getSprite("sticking_wild_background_blue.png", x, 25, {x: .5, y: 0});
        bg.name = "background";
        bg.red = false;
        container.addChild(bg);
    }

    static addJoker(container, x) {
        let joker = Commander.getSprite("joker.png", x, 15, {x: .5, y: 0});
        joker.name = "joker";
        container.addChild(joker);
    }

    getBetIndex() {
        return this.commander.wallet.getBetSet().indexOf(this.commander.wallet.getBet())
    }
}